export const ROUTES = {
  ROOT: '/',
  LOGIN: '/login',
  FORGOT_PASSWORD: '/forgot-password',
  RESET_PASSWORD: '/reset-password',
  ADMISSIONS: '/admissions',
  ADMISSIONS_NEW: '/admissions/new',
  ADMISSIONS_EDIT: '/admissions/:id/edit',
  ADMISSIONS_STUDENT_DETAIL: '/admissions/:admissionId/detail',
  INSTALLMENTS: '/installments',
  INSTALLMENTS_NEW: '/installments/new',
  INSTALLMENTS_TRANSACTIONS: '/installments/:admissionId/transactions',
  DASHBOARD: '/dashboard',
  USERS: '/users',
  // Nested under /admissions (not /installments) so TopbarNav's prefix-based
  // active-tab check keeps the Admission tab highlighted here — same reason
  // ADMISSIONS_STUDENT_DETAIL/INSTALLMENTS_TRANSACTIONS below are nested
  // under their own tabs even though all three render the same page.
  STUDENTS: '/admissions/students',
  STUDENT_DETAIL: '/admissions/students/:admissionId',
  REPORTS: '/reports',
  SETTINGS: '/settings',
  NOT_FOUND: '*',
} as const;

export type RouteKey = keyof typeof ROUTES;
